var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.011 10.834a.621.621 0 00-.62.62v1.452a.621.621 0 00.62.62h.787a.621.621 0 00.62-.62v-1.452a.621.621 0 00-.62-.62H2.01zM16.557 13.574h-.787a.67.67 0 01-.668-.669v-1.451a.67.67 0 01.668-.669h.787a.67.67 0 01.669.669v1.451a.67.67 0 01-.669.669z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.036 12.412H2.486c-.617 0-1.119-.363-1.119-.81V8.996l.673-.708h14.573l.541.71v2.604c0 .447-.502.81-1.118.81z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.55 9.591H2.117l-.146-2.249.093-.23.543-1.335h13.356l.733 1.516-.146 2.298z",
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vehicle_svg__filter0_f_17997_113929)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.375,
    cy: 8.645,
    rx: 2,
    ry: 4.054,
    transform: "rotate(-45 9.375 8.645)",
    fill: "#F5F7FA"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.672 7.298l-.108 1.69h-3.175V7.731l3.192-.62.09.186zM5.229 7.732v1.256H2.1l-.107-1.642.091-.225 3.144.611z",
    fill: "#6F6F6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.88 6.163H2.687l1.407-4.69A.942.942 0 014.99.797l8.739-.083a.946.946 0 01.925.709l1.227 4.74z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.866 5.72L3.7 5.588a.09.09 0 01-.084-.118l1.07-3.34a.09.09 0 01.086-.063h8.98a.09.09 0 01.087.063l1.114 3.472a.09.09 0 01-.087.118z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.694 6.067H.714v-.435a.531.531 0 01.531-.53h1.45v.965zM17.854 6.067h-1.979v-.965h1.449a.531.531 0 01.53.53v.435z",
    fill: "#EBEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vehicle_svg__filter0_f_17997_113929",
    x: 2.988,
    y: 2.258,
    width: 12.773,
    height: 12.774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.595,
    result: "effect1_foregroundBlur_17997_113929"
  })))));
}
export default __webpack_public_path__ + "static/media/vehicle.684ec8ae.svg";
export { SvgVehicle as ReactComponent };